import { NgModule } from '@angular/core';
import { CommonModule, DatePipe, TitleCasePipe } from '@angular/common';
import { SalesDnaComponent } from './sales-dna.component';
import { ConfigurePipelineComponent } from './components/configure-pipeline/configure-pipeline.component';
import { ConfigureNodeComponent } from './components/configure-node/configure-node.component';
import { RouterModule } from '@angular/router';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SelectedProjectComponent } from './components/selected-project/selected-project.component';
import { SalesDnaRoutingModule } from './sales-dna-routing.module';
import { TextPrettyPipe } from 'src/app/pipes/text-pretty.pipe';
import { FormBuilderSecondaryComponent } from 'src/app/components/form-builder-secondary/form-builder-secondary.component';

import { ShareProjectConfigurationComponent } from './components/share-project-configuration/share-project-configuration.component';
import { MySolutionsComponent } from './components/my-solutions/my-solutions.component';
import { SolutionsInProductionComponent } from './components/solutions-in-production/solutions-in-production.component';
import { SolutionsVersionsComponent } from './components/solutions-versions/solutions-versions.component';
import { CreateSolutionsComponent } from './components/create-solutions/create-solutions.component';
import { MySolutionHomepageComponent } from './components/my-solution-homepage/my-solution-homepage.component';
import { MaterialModule } from 'src/app/material/material.module';
import { AddProjectsComponent } from './components/add-projects/add-projects.component';
import { ShowDialogsComponent } from 'src/app/components/show-dialogs/show-dialogs.component';
import { NamingSizePipe } from 'src/app/pipes/naming-size.pipe';
import { SolutionConfigurationFormComponent } from './components/solution-configuration-form/solution-configuration-form.component';
import { SolutionExecutorFormComponent } from './components/solution-executor-form/solution-executor-form.component';
import { JobSchedulerComponent } from 'src/app/components/job-scheduler/job-scheduler.component';
import { ExcludeKeysPipe } from 'src/app/pipes/exclude-keys.pipe';
import { VersionDocumentationComponent } from './components/version-documentation/version-documentation.component';

@NgModule({
  declarations: [
    SalesDnaComponent,
    ConfigurePipelineComponent,
    ConfigureNodeComponent,
    SelectedProjectComponent,
    ShareProjectConfigurationComponent,
    MySolutionsComponent,
    SolutionsInProductionComponent,
    SolutionsVersionsComponent,
    CreateSolutionsComponent,
    MySolutionHomepageComponent,
    AddProjectsComponent,
    SolutionConfigurationFormComponent,
    SolutionExecutorFormComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    SalesDnaRoutingModule,
    TextPrettyPipe,
    TitleCasePipe,
    ExcludeKeysPipe,
    DatePipe,
    FormBuilderSecondaryComponent,
    ShowDialogsComponent,
    NamingSizePipe,
    JobSchedulerComponent,
    VersionDocumentationComponent
  ],
  exports: [
    SalesDnaComponent,
    ConfigurePipelineComponent,
    ConfigureNodeComponent,
    MySolutionsComponent,
    SolutionsInProductionComponent
  ],
  bootstrap: [ShareProjectConfigurationComponent],
})
export class SalesDnaModule {}
